import styles from "./partners-group.module.scss";
import alipay from "@/assets/footer/logos/alipay.svg";
import master from "@/assets/footer/logos/master.svg";
import paypal from "@/assets/footer/logos/paypal.svg";
import visa from "@/assets/footer/logos/visa.svg";
import tnt from "@/assets/footer/logos/tnt.svg";
import fedex from "@/assets/footer/logos/fedex.svg";
import dhl from "@/assets/footer/logos/dhl.svg";
import { Icon } from "@/elements-react/fix-icon";

const banks = [visa, master, alipay, fedex, dhl, paypal, tnt];

export const PartnersGroup = () => {
  return (
    <div className={styles.partnersGroup}>
      {banks.map((src, idx) => (
        <Icon key={idx} className={styles.icon} src={src} />
      ))}
    </div>
  );
};
